<template>
  <section v-if="profile" class="c-shopping-confirm-password">
    <div class="c-shopping-confirm-password__modal">
      <div class="c-shopping-confirm-password__header">
        <h1 class="has-text-weight-bold">Confirmação de senha</h1>
        <a
          @click="close"
          href="#"
          class="c-shopping-confirm-password__icon icon has-text-white"
        >
          <base-icon name="painel/close-icon" width="20" height="20" />
        </a>
      </div>

      <div class="c-shopping-confirm-password__wrapper">
        <p>
          Para finalizar a compra,<br />confirme a senha da sua conta no<br />Casar.com
        </p>
      </div>

      <div class="c-shopping-confirm-password__details">
        <p><strong class="has-text-support">Casar.com</strong></p>

        <p v-if="profile">
          <strong> {{ profile.owner_full_name }} </strong><br />
          {{ profile.owner_cpf }}
        </p>
      </div>
      <form v-on:submit.prevent="submit">
        <div class="c-shopping-confirm-password__wrapper">
          <base-input
            v-on:input="password = $event"
            :value="password"
            :hasError="
              validation.hasError('password') || (errors ? true : false)
            "
            :firstError="
              validation.firstError('password') || (errors ? errors : '')
            "
            :isPassed="validation.isPassed('password') && !errors"
            type="password"
          >
            Digite sua senha
          </base-input>
        </div>

        <div class="c-shopping-confirm-password__button has-text-centered">
          <button
            :disabled="
              !validation.isPassed('password') ||
              formLoading ||
              errors ||
              externalToken
            "
            :class="{
              'is-support': externalToken,
              'is-primary':
                validation.isPassed('password') &&
                !formLoading &&
                !externalToken,
              'is-loading': formLoading,
            }"
            class="button is-black is-big"
            type="submit"
          >
            {{ buttonLabel }}
          </button>
        </div>
      </form>

      <ValidationPhoneModal
        ref="modalValidationPhone"
        :isRegisterNumber="false"
        :btnCloseAtivated="true"
        :nextStep="'shopping'"
        @validation-phone="goToValidationPhone"
      />
    </div>
  </section>
</template>

<script>
import BaseInput from '@/components/BaseInput.vue'
import ValidationPhoneModal from '@/components/Profile/Sms/ValidationPhoneModal.vue'

import LogonApi from '@/lib/api/Logon'
import axios from 'axios'

import loadingViewMixin from '@/mixins/loadingViewMixin'
import SimpleVueValidator from 'simple-vue-validator'

const Validator = SimpleVueValidator.Validator.create({
  templates: {
    required: 'Este campo não pode ficar vazio',
  },
})

const API_URL = process.env.VUE_APP_API_URL

export default {
  mixins: [SimpleVueValidator.mixin, loadingViewMixin],

  components: {
    BaseInput,
    ValidationPhoneModal,
  },

  validators: {
    password(value) {
      return Validator.value(value).required()
    },
  },

  computed: {
    buttonLabel() {
      return this.externalToken ? 'Senha confirmada!' : 'Confirmar'
    },
  },

  data() {
    return {
      wed_id: false,
      password: null,
      errors: false,
      externalToken: null,
      formLoading: false,
      profile: null,
    }
  },

  watch: {
    password() {
      this.errors = false
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getOwnerInfo(to.query.wed_id)
    })
  },

  methods: {
    submit() {
      this.formLoading = true
      this.$validate().then((success) => {
        if (success) this.getExternalToken()
      })
    },

    getExternalToken() {
      const logonApi = new LogonApi()
      const wed_id = this.wed_id

      logonApi
        .getExternalToken({
          wed_id,
          senha: this.password,
        })
        .then((response) => {
          if (response.data.errors) {
            this.errors = 'Usuário e/ou senha inválidos!'
            window.parent.postMessage({ retorno: 'passwordUnconfirmed' }, '*')
          } else {
            this.externalToken = response.data.token
            this.$refs.modalValidationPhone.open(response.data)
          }
        })
        .catch(() => {
          this.errors = 'Houve algum problema, tente novamente em instantes!'
          this.formLoading = false
        })
    },

    getOwnerInfo(wed_id) {
      this.wed_id = Number(wed_id)
      const isNumber = Number.isInteger(this.wed_id)

      if (isNumber) {
        const urlApiPublic = API_URL + '/v1/wallets/'
        axios
          .get(urlApiPublic + this.wed_id + '/owner-info')
          .then((response) => {
            this.profile = response.data.data
            this.loading = false
          })
      }
    },

    goToValidationPhone(token) {
      if (token) {
        window.parent.postMessage(
          {
            retorno: 'tokenConfirmed',
            token: token,
          },
          '*'
        )
        this.formLoading = false
      } else {
        this.errors = 'Houve algum problema, tente novamente em instantes!'
        this.formLoading = false
      }
    },

    close() {
      window.parent.postMessage({ retorno: 'closeConfirmPasswordModal' }, '*')
    },
  },
}
</script>

<style lang="scss">
html,
body {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: transparent;
}

.c-shopping-confirm-password {
  width: 100%;
  height: 100vh;
  background-color: rgba($black, 0.85);

  &__modal {
    @include position(absolute, auto, 0, 0, 0);
    width: 100%;
    max-height: 420px;
    height: 100vh;
    z-index: 2;
    background-color: $white;
    @media (max-width: $tablet) {
      padding-bottom: 48px;
      max-height: 480px;
      overflow-y: auto;
    }
  }

  @media (max-width: $tablet) {
    &__button {
      height: 84px;
    }
  }

  &__header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    text-align: center;
    background-color: #f7f9fb;
  }

  &__icon {
    @include position(absolute, 0, 1em, 0, auto);
    width: 40px;
    height: 40px;
    color: $white;
    background-color: $error;
  }

  &__wrapper {
    max-width: 230px;
    margin: 25px auto;
    text-align: center;
  }

  &__details {
    padding: 1.5em;
    text-align: center;
    background-color: $gray-2;
  }
}
</style>
